import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormControl} from '@angular/forms';

@Component({
  selector: 'app-multiselect-dropdown',
  templateUrl: './multiselect-dropdown.component.html',
  styleUrls: ['./multiselect-dropdown.component.scss']
})
export class MultiselectDropdownComponent implements OnInit {
  @Input() options: MultiSelectOption[];
  @Output() change = new EventEmitter<MultiSelectOptionValue[]|undefined>();
  optionForm = new FormControl();
  selectedValue = [];
  optionSelected = [];
  isChecked = false;
  singleSelect = true;
  state = '';
  constructor() {
  }

  ngOnInit() {
  }

  removeSelect(i, mulOpt, selectName) {
    if (selectName === 'All') {
      this.selectedValue = undefined;
    }
    this.selectedValue.splice(i, 1); // my ngModel
    mulOpt.writeValue(this.selectedValue); // reference variable of md-select
    this.passValue(this.selectedValue);
  }

  removeAll() {
    this.selectedValue = undefined;
    this.singleSelect = true;
    this.isChecked = false;
    this.state = '';
    this.change.emit(undefined);
  }

  onChange() {
    this.passValue(this.optionForm.value);
  }

  passValue(data) {
    if (data.length >= 0) {
      let option: MultiSelectOptionValue;
      const emit = [];
      for (let i = 0; i < data.length; ++i) {
        this.optionSelected[i] = this.options.find(x => x.name === data[i]).id;
        option = {id: this.optionSelected[i]};
        emit.push(option);
      }
      this.change.emit(emit);
    }
  }
  allChecked(e, mulOpt) {
    if (e.target.checked === true) {
      this.singleSelect = false;
      this.isChecked = true;
      this.state = 'checked';
      this.selectedValue = this.options.map(res => res.name);
      this.passValue(this.selectedValue);
      mulOpt.writeValue(this.selectedValue);
    }
    if (e.target.checked === false) {
      this.singleSelect = true;
      this.isChecked = false;
      this.state = '';
      this.change.emit(undefined);
      this.selectedValue = undefined;
    }

  }
}

export interface MultiSelectOptionValue {
  id: number|string;
}

export interface MultiSelectOption extends MultiSelectOptionValue {
  name: string;
}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/utilities/components/multiselect-dropdown/multiselect-dropdown.component.ts